import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { logger } from "@/lib/logger";
import { useAuth } from "@/context/AuthContext";

const AgencyContext = createContext({ agency: null, refresh: () => {} });

export const AgencyProvider = ({ children }) => {
  const { user } = useAuth();
  const [agency, setAgency] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/agency-settings");
      setAgency(data);
    } catch (e) { logger.error("Agency load failed:", e); setAgency(null); }
  }, []);

  useEffect(() => {
    if (user && user !== false) refresh();
  }, [user, refresh]);

  const value = useMemo(() => ({ agency, refresh }), [agency, refresh]);
  return <AgencyContext.Provider value={value}>{children}</AgencyContext.Provider>;
};

export const useAgency = () => useContext(AgencyContext);
